<div class="markdown-wrap">
  <div #editor></div>
</div>
